import { useState, useEffect } from "react";
import createAxiosInstanceNew from "../Api/AxiosInstance/AxiosInstance";

const useGet = (url, params = {}, fetchOnMount = false) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(fetchOnMount);
  const [error, setError] = useState(null);

  const getData = async () => {
    setLoading(true);
    try {
      const axiosInstance = await createAxiosInstanceNew();

      const response = await axiosInstance.get(url, {
        params: params,
      });
      if (response.data.statusCode === 200) {
        setData(response.data.body);
        setError(null);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fetchOnMount) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return { data, loading, error, refetch: getData };
};

export default useGet;
